(function() {
  var ConfirmDialog, SelectBox, ValidationEngine, accounting,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  SelectBox = App.loadClass('core::SelectBox');

  accounting = App.loadClass('bower::accounting/accounting');

  ConfirmDialog = App.loadClass('core::ConfirmDialog');

  exports.RuppOrdersDialogDiscountsHandler = (function(superClass) {
    extend(RuppOrdersDialogDiscountsHandler, superClass);

    function RuppOrdersDialogDiscountsHandler() {
      this.removeExpiredEarlyPayDiscounts = bind(this.removeExpiredEarlyPayDiscounts, this);
      this.hideUsedDiscounts = bind(this.hideUsedDiscounts, this);
      return RuppOrdersDialogDiscountsHandler.__super__.constructor.apply(this, arguments);
    }

    RuppOrdersDialogDiscountsHandler.prototype.init = function() {
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout-discounts';
      this.layoutSelector = '#orders_steps_container';
      this.loadLayout();
      return this.dataLoaded = false;
    };

    RuppOrdersDialogDiscountsHandler.prototype.afterLoadLayout = function(selector, response) {
      var crop, cust, custnames, customer, key, ref, ref1, sales_rep, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      this.data = response;
      accounting.settings.currency.format = {
        pos: '%s%v',
        neg: '(%s%v)',
        zero: '%s%v'
      };
      debugLog('afterLoadLayout: sales_rep');
      debugLog(sales_rep);
      sales_rep = this.taffyObjects['sales_reps']({
        'id': {
          '==': this.parent.saveData['sales_rep_fk']
        }
      }).select('name');
      debugLog('afterLoadLayout: sales_rep');
      debugLog(sales_rep);
      $('#sales_rep').text(sales_rep);
      custnames = '';
      ref1 = this.parent.saveData['customers'];
      for (key in ref1) {
        cust = ref1[key];
        customer = this.taffyObjects['customers']({
          'id': {
            '==': cust.users_id
          }
        }).select('name');
        if (custnames !== '') {
          custnames += ', ';
        }
        custnames += customer;
      }
      $('#customers').text(custnames);
      crop = this.taffyObjects['crops']({
        'id': {
          '==': this.parent.saveData['crops_id']
        }
      }).select('name');
      $('#crop').text(crop);
      $('#avg_population').bind('change', function() {
        $(this).val(ths.parseNumber($(this).val()));
        return ths.calculateTotals();
      });
      this.discount_id = 0;
      $('#btn_add_discount').bind('click', function() {
        var data, discount_id, discounts;
        discount_id = $(this).data('id');
        $(this).removeData('id');
        if (discount_id == null) {
          discount_id = ths.discount_id;
        }
        data = $('.add-disc-tmpl').render();
        data = $($.parseHTML(data));
        discounts = [['Volume Discount', 'Volume Discount'], ['Early Order Discount', 'Early Order Discount'], ['Other Discount', 'Other Discount']];
        SelectBox.render(discounts, data.find('.sel_disc_amnt'));
        data.find('.order-data').attr('data-dynamic-btn', '#btn_add_discount');
        data.find('.order-data').attr('data-dynamic-id', discount_id);
        data.find('.btn_disc_delete').attr('data-dynamic-id', discount_id);
        data.find('.disc_units').hide();
        ths.discount_id = parseInt(discount_id) + 1;
        data.appendTo('.discounts_container');
        return ths.hideUsedDiscounts(data.find('.sel_disc_amnt'));
      });
      $('.disc-outer-container').delegate('.btn_disc_delete', 'click', function() {
        ths.parent.deleteFormData('discounts', $(this).data('dynamic-id'));
        $(this).closest('.disc-row').remove();
        ths.calculateTotals();
        return ths.hideUsedDiscounts();
      });
      $('.discounts_container').delegate('.sel_disc_amnt', 'change', (function(_this) {
        return function() {
          _this.calculateTotals();
          return _this.hideUsedDiscounts();
        };
      })(this));
      $('.discounts_container').delegate('.txt_disc_amnt', 'change', (function(_this) {
        return function() {
          return _this.calculateTotals();
        };
      })(this));
      $('.discounts_container').delegate('.txt_disc_units', 'change', (function(_this) {
        return function() {
          return _this.calculateTotals();
        };
      })(this));
      if (this.parent.editable) {
        this.validator = new ValidationEngine();
        this.validator.makeFormValidator('discounts', '#discounts_container', '#discounts_errors', (function(_this) {
          return function(valid) {
            _this.parent.saveFormData();
            if (valid) {
              return _this.parent.save('Saving order...');
            }
          };
        })(this));
        this.validator.registerRule({
          selector: '.validate-moneyIsPositive',
          text: '%s must be greater than 0',
          func: function(elem) {
            var val;
            val = accounting.unformat(elem.text());
            return !val || ($.isNumeric(val) && parseFloat(val) > 0);
          }
        });
        this.validator.registerRule({
          selector: '.validate-volumeUnits',
          text: 'The total number of discounted units must not exceed the total number of units',
          func: function(elem) {
            var count, input, j, len, ref2;
            count = 0;
            ref2 = $('.disc-row');
            for (j = 0, len = ref2.length; j < len; j++) {
              input = ref2[j];
              if ($(input).find('.sel_disc_amnt').val() === "Volume Discount") {
                count += parseInt($(input).find('.txt_disc_units').val());
              }
            }
            return !$(total_units).text() || count <= parseInt($(total_units).text());
          }
        });
      }
      $('.jdf-discount').hide();
      $('#payment_types_id').bind('change', function() {
        var can_early_pay, early_pay_discounts, id;
        id = $(this).val();
        if (!id) {
          $('#early_pay_discounts_id').val('').prop('disabled', 'disabled');
          $('#early_pay_percent').val('').prop('disabled', 'disabled');
          return;
        }
        can_early_pay = ths.taffyObjects['payment_types']({
          id: {
            '==': id
          }
        }).select('can_early_pay')[0];
        if (can_early_pay) {
          $('.early-pay-discount').show();
          $('#net_total_with').show();
          $('#net_total_body').show();
          $('.early-pay-type').text('Early Pay');
          $('#early_pay_discounts_id').prop('disabled', false);
          $('#early_pay_percent').prop('disabled', false);
          early_pay_discounts = ths.taffyObjects['early_pay_discounts']().select('id', 'name');
          SelectBox.render(early_pay_discounts, $('#early_pay_discounts_id'));
          ths.removeExpiredEarlyPayDiscounts();
        } else {
          $('#early_pay_discounts_id').val('');
          $('.early-pay-discount').hide();
          $('#net_total_with').hide();
          $('#net_total_body').hide();
        }
        return ths.calculateTotals();
      });
      $('#early_pay_percent').bind('change', (function(_this) {
        return function() {
          return _this.calculateTotals();
        };
      })(this));
      this.parent.loadFormData();
      return this.parent.dialog.find('.message_writer').message_writer({
        autoHide: false
      });
    };

    RuppOrdersDialogDiscountsHandler.prototype.hideUsedDiscounts = function(discount) {
      var allDiscounts, discounts, globalDiscount, j, len, optionToHide, results;
      allDiscounts = $('.discounts_container .sel_disc_amnt');
      if (discount != null) {
        discounts = [discount];
      } else {
        discounts = allDiscounts;
      }
      results = [];
      for (j = 0, len = discounts.length; j < len; j++) {
        discount = discounts[j];
        discount = $(discount);
        discount.find('option').show();
        results.push((function() {
          var k, len1, results1;
          results1 = [];
          for (k = 0, len1 = allDiscounts.length; k < len1; k++) {
            globalDiscount = allDiscounts[k];
            globalDiscount = $(globalDiscount);
            if (globalDiscount.is(discount)) {
              continue;
            }
            optionToHide = globalDiscount.val();
            if (optionToHide !== 'Volume Discount') {
              results1.push(discount.find("option[value='" + optionToHide + "']").hide());
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };

    RuppOrdersDialogDiscountsHandler.prototype.afterLoadData = function() {
      var ths;
      ths = this;
      this.dataLoaded = true;
      $('#early_pay_discounts_id').bind('change', (function(_this) {
        return function() {
          $('#early_pay_percent').val('');
          return _this.calculateTotals();
        };
      })(this));
      if (!this.parent.saveData['address2']) {
        $('[name="address2"]').next().remove();
      }
      this.calculateTotals();
      return $('#btn_orders_next').prop('disabled', false);
    };

    RuppOrdersDialogDiscountsHandler.prototype.removeExpiredEarlyPayDiscounts = function() {
      var selected, whenOrderPlaced;
      selected = $('#early_pay_discounts_id').val();
      whenOrderPlaced = moment(this.parent.saveData.order_date);
      return $('#early_pay_discounts_id option').each((function(_this) {
        return function(i, el) {
          var date;
          el = $(el);
          date = moment(el.text()).add(1, 'days');
          if (el.attr('value') !== selected && whenOrderPlaced.diff(date) > 0) {
            return el.remove();
          }
        };
      })(this));
    };

    RuppOrdersDialogDiscountsHandler.prototype.calculateTotals = function() {
      var ths;
      ths = this;
      if (!this.dataLoaded) {
        return;
      }
      this.parent.saveFormData();
      return $.post('backend/grower/rupp-orders/new-pricing-summary', JSON.stringify(this.parent.saveData), (function(_this) {
        return function(data) {
          var amnt, discount, j, len, ref, results, sel;
          data = $.parseJSON(data);
          $(_this.layoutSelector).find('#avg_cost_per_acre').text(accounting.formatMoney(data.avg_net_cost_per_acre));
          $(_this.layoutSelector).find('#total_units').text(data.total_units);
          $(_this.layoutSelector).find('#avg_unit_cost').text(accounting.formatMoney(data.avg_gross_unit_cost));
          $(_this.layoutSelector).find('#subtotal').text(accounting.formatMoney(data.subtotal));
          $(_this.layoutSelector).find('#net_total').text(accounting.formatMoney(data.net_total));
          if (data.early_pay_percent) {
            $(_this.layoutSelector).find('#early_pay_percent').val(data.early_pay_percent);
          } else {
            $(_this.layoutSelector).find('#early_pay_percent').val('');
          }
          if (data.early_pay_amnt != null) {
            $(_this.layoutSelector).find('#early_amnt').text(accounting.formatMoney(data.early_pay_amnt));
          } else {
            $(_this.layoutSelector).find('#early_amnt').text('');
          }
          if (data.jdf_percent != null) {
            $(_this.layoutSelector).find('#jdf_percent').text(data.jdf_percent + '%');
          } else {
            $(_this.layoutSelector).find('#jdf_percent').text('');
          }
          if (data.jdf_amnt != null) {
            $(_this.layoutSelector).find('#jdf_amnt').text(accounting.formatMoney(data.jdf_amnt));
          } else {
            $(_this.layoutSelector).find('#jdf_amnt').text('');
          }
          $(_this.layoutSelector).find('#final_total').text(accounting.formatMoney(data.net_total_with_early_pay));
          $(_this.layoutSelector).find('#avg_cost_per_acre').text(accounting.formatMoney(data.avg_net_cost_per_acre));
          $(_this.layoutSelector).find('.discounts_container div.volume-discount-container').remove();
          $(_this.layoutSelector).find('.discounts_container select.sel_disc_amnt').attr('data-needs-update', true);
          $(_this.layoutSelector).find('.discounts_container .disc-amnt').text('');
          if (!_this.parent.editable) {
            $(_this.layoutSelector).find(".btn-disc-delete").prop('disabled', true);
          }
          ref = data.discounts;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            discount = ref[j];
            amnt = accounting.formatMoney(-1 * discount.total_amnt);
            sel = $(_this.layoutSelector).find('.discounts_container select.sel_disc_amnt[data-needs-update]')[0];
            sel = $(sel);
            sel.closest('.disc-row').find('.txt_disc_amnt').val(discount.amnt);
            sel.closest('.disc-row').find('.txt_disc_units').val(discount.units);
            sel.closest('.disc-row').find('.disc_amnt').text(amnt);
            if (discount.name === 'Volume Discount') {
              sel.closest('.disc-row').find('.disc_units').show();
            } else {
              sel.closest('.disc-row').find('.disc_units').hide();
            }
            results.push(sel.removeAttr('data-needs-update'));
          }
          return results;
        };
      })(this));
    };

    RuppOrdersDialogDiscountsHandler.prototype.parseNumber = function(val) {
      return Number(val.replace(/[^0-9\.]+/g, ''));
    };

    return RuppOrdersDialogDiscountsHandler;

  })(Handler);

}).call(this);
